import { Match } from '../models/analytics-api/search_result.model';
import { IQueryFilter } from '../interfaces/query-filter.interface';
import { Dimension, DimensionProperty } from './analytics-api/schema.model';

export class QueryFilter {
  public dataset?: string;
  public displayName?: string;
  public type: string;
  public key: string;
  public values: Match[] | string;
  public dimension: Dimension = undefined;
  public dimensionProperty: DimensionProperty = undefined;
  public isSearchable?: boolean;

  constructor(
    object: IQueryFilter
  ) {
    this.type = object.type;
    this.values = object.values || [];

    if (!!object.dimension) {
      const properties = object.dimension.properties?.map(dp => new DimensionProperty(dp.name, dp.meta, dp.isSearchable, dp.dimensionName));
      this.dimension = new Dimension(object.dimension.name, object.dimension.meta, properties, object.dimension.isSearchable);
    }

    if (!!object.dimension_property) {
      this.dimensionProperty = new DimensionProperty(object.dimension_property.name, object.dimension_property.meta, object.dimension_property.isSearchable, object.dimension?.name);
    }

    if (object.dataset) {
      this.dataset = object.dataset;
    }

    if (object.is_searchable) {
      this.isSearchable = object.is_searchable;
    }

    this.key = this.dimension ? this.combinedKey : object.key;
  }

  public get queryString() {
    switch (this.type) {
      case 'any':
      case 'not_any':
        return this.slice.length ? `${this.dimension?.name || this.key}:${this.type}:${this.slice}` : '';
      case 'na':
      case 'not_na':
        if (this.dimensionProperty) {
          return `${this.key}:${this.type === 'na' ? 'any' : 'not_any'}:`;
        } else {
          return `${this.dimension?.name || this.key}:${this.type === 'na' ? 'any' : 'not_any'}:`;
        }
      default:
        if (this.dimension) {
          return `${this.combinedKey}:${this.type}:${this.slice}`;
        } else {
          return `${this.key}.${this.key}:${this.type}:${this.slice}`;
        }
    }
  }

  private get isDimensionProperty() {
    return !!this.dimensionProperty;
  }

  private get slice() {
    if (Array.isArray(this.values)) {
      return this.values.map(value => encodeURIComponent(value.slice)).join(';');
    } else {
      return encodeURIComponent(this.values);
    }
  }

  private get combinedKey() {
    if (this.isDimensionProperty) {
      return `${this.dimension.name}.${this.dimensionProperty.name}`;
    } else {
      return `${this.dimension.name}.${this.dimension.name}`;
    }
  }

  asJson() {
    return {
      type: this.type,
      values: this.values,
      is_searchable: this.isSearchable,
      dimension: this.dimension && { name: this.dimension.name },
      dimension_property: this.dimensionProperty && { name: this.dimensionProperty.name },
      key: this.key,
    }
  }

}
